import { iconForName } from "@/components/artifacts/iconForName.ts";
import { cn } from "@/lib/utils.ts";
import type { ArtifactComponent } from "@/types/artifacts-view.ts";

type StatusBadgeComponentData = Extract<ArtifactComponent, { type: "statusBadge" }>;

const severityClass = (severity: StatusBadgeComponentData["severity"]): string => {
  switch (severity) {
    case "success":
      return "text-green-600 bg-green-50";
    case "warning":
      return "text-amber-600 bg-amber-50";
    case "error":
      return "text-red-600 bg-red-50";
    case "muted":
      return "text-muted-foreground bg-muted";
    case "info":
    default:
      return "text-blue-600 bg-blue-50";
  }
};

export const StatusBadgeBlock = ({ component }: { component: StatusBadgeComponentData }) => {
  const Icon = component.icon ? iconForName(component.icon) : null;
  return (
    <div className="flex flex-row items-center gap-2">
      <div
        className={cn(
          "flex flex-row items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium",
          severityClass(component.severity),
        )}
      >
        {Icon ? <Icon className="size-3.5" /> : null}
        {component.label}
      </div>
    </div>
  );
};
